/**
 * Product card quick add functionality
 * Shows size selector when quick add button is clicked
 */

class ProductCard {
  constructor(element) {
    this.element = element;
    this.form = element.querySelector('.form');
    this.variantInput = element.querySelector('[data-variant-input]');
    this.variantsData = this.getVariantsData();
    this.quickAddTrigger = element.querySelector('.quick-add-trigger');
    this.sizeSelector = element.querySelector('.quick-size-selector');
    this.sizeButtons = element.querySelectorAll('.quick-size-btn');

    this.init();
  }

  getVariantsData() {
    const dataElement = this.element.querySelector('[data-product-variants]');
    return dataElement ? JSON.parse(dataElement.textContent) : [];
  }

  init() {
    if (!this.quickAddTrigger) return;

    // Show size selector when quick add button is clicked
    this.quickAddTrigger.addEventListener('click', (e) => {
      e.preventDefault();

      // If only one variant, add directly to cart
      if (this.variantsData.length === 1) {
        this.addToCart();
      } else {
        this.showSizeSelector();
      }
    });

    // Handle size button clicks
    this.sizeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const size = button.dataset.size;
        this.selectSizeAndSubmit(size);
      });
    });

    // Close size selector when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.element.contains(e.target) && this.sizeSelector.classList.contains('visible')) {
        this.hideSizeSelector();
      }
    });

    // Reset loading state after cart update
    document.addEventListener('cart:updated', () => {
      this.resetLoadingState();
    });
  }

  resetLoadingState() {
    this.quickAddTrigger.classList.remove('loading');
    const spinner = this.quickAddTrigger.querySelector('.loading__spinner');
    if (spinner) {
      spinner.classList.add('hidden');
      spinner.style.display = 'none';
    }
  }

  showSizeSelector() {
    this.quickAddTrigger.classList.remove('visible');
    this.sizeSelector.classList.add('visible');
  }

  hideSizeSelector() {
    this.sizeSelector.classList.remove('visible');
    this.quickAddTrigger.classList.add('visible');
  }

  addToCart() {
    // Show loading state on the trigger button
    this.quickAddTrigger.classList.add('loading');
    const spinner = this.quickAddTrigger.querySelector('.loading__spinner');
    if (spinner) {
      spinner.classList.remove('hidden');
      spinner.style.display = '';
    }

    // Trigger form submit event (product-form custom element will handle it)
    const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
    this.form.dispatchEvent(submitEvent);
  }

  selectSizeAndSubmit(size) {
    // Find matching variant for selected size
    const matchingVariant = this.variantsData.find(variant => {
      // Check all option fields to find the size match
      return (
        (variant.option1 === size || variant.option2 === size || variant.option3 === size) &&
        variant.available
      );
    });

    if (matchingVariant) {
      // Update hidden variant input
      this.variantInput.value = matchingVariant.id;

      // Hide the size selector
      this.hideSizeSelector();

      // Add to cart
      this.addToCart();
    }
  }
}

// Initialize all product cards
function initProductCards() {
  document.querySelectorAll('.product-form').forEach(form => {
    new ProductCard(form);
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductCards);
} else {
  initProductCards();
}
